
import { Component, Vue } from 'vue-property-decorator';
import LayoutDefault from '@/layouts/LayoutDefault.vue';
import ProfileRestaurants from '@/components/profile/ProfileRestaurants.vue';
import ProfileForm from '@/components/profile/ProfileForm.vue';

@Component({
  components: { ProfileForm, ProfileRestaurants, LayoutDefault },
})
export default class MyProfile extends Vue {
  get canUseMenuEngineering(): boolean {
    return this.$store.getters['auth/hasAccess']({
      action: 'PUT',
      resource: '/restaurant',
    });
  }

  created() {
    this.$store.dispatch('auth/getUser');
  }
}
